/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * PanLuma API
 * Enterprise productivity application API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type { HTTPValidationError } from '../models/hTTPValidationError';

import type { NotificationAllPreferencesResponse } from '../models/notificationAllPreferencesResponse';

import type { NotificationBulkEventPreferenceUpdate } from '../models/notificationBulkEventPreferenceUpdate';

import type { NotificationBulkTenantDefaultUpdate } from '../models/notificationBulkTenantDefaultUpdate';

import type { NotificationCatalogResponse } from '../models/notificationCatalogResponse';

import type { NotificationModuleCatalogResponse } from '../models/notificationModuleCatalogResponse';

import type { NotificationModulePreferenceUpdate } from '../models/notificationModulePreferenceUpdate';

import type { NotificationModulePreferences } from '../models/notificationModulePreferences';

import type { NotificationPreferenceResetResult } from '../models/notificationPreferenceResetResult';

import type { NotificationPreferenceUpdateResult } from '../models/notificationPreferenceUpdateResult';

import type { NotificationPreferencesResponse } from '../models/notificationPreferencesResponse';

import type { NotificationTenantDefaultsResponse } from '../models/notificationTenantDefaultsResponse';

import { customInstance } from '../../../shared/api/axiosInstance';

/**
 * Get the notification events catalog (all modules).
 * @summary Get Catalog
 */
export const getCatalogApiV1NotificationPreferencesCatalogGet = (
  signal?: AbortSignal
) => {
  return customInstance<NotificationCatalogResponse>({
    url: `/api/v1/notification-preferences/catalog`,
    method: 'GET',
    signal
  });
};

export const getGetCatalogApiV1NotificationPreferencesCatalogGetQueryKey =
  () => {
    return [`/api/v1/notification-preferences/catalog`] as const;
  };

export const getGetCatalogApiV1NotificationPreferencesCatalogGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getCatalogApiV1NotificationPreferencesCatalogGet>
  >,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<
        ReturnType<typeof getCatalogApiV1NotificationPreferencesCatalogGet>
      >,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetCatalogApiV1NotificationPreferencesCatalogGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCatalogApiV1NotificationPreferencesCatalogGet>>
  > = ({ signal }) => getCatalogApiV1NotificationPreferencesCatalogGet(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<typeof getCatalogApiV1NotificationPreferencesCatalogGet>
    >,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetCatalogApiV1NotificationPreferencesCatalogGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getCatalogApiV1NotificationPreferencesCatalogGet>>
  >;
export type GetCatalogApiV1NotificationPreferencesCatalogGetQueryError =
  unknown;

export function useGetCatalogApiV1NotificationPreferencesCatalogGet<
  TData = Awaited<
    ReturnType<typeof getCatalogApiV1NotificationPreferencesCatalogGet>
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getCatalogApiV1NotificationPreferencesCatalogGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getCatalogApiV1NotificationPreferencesCatalogGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getCatalogApiV1NotificationPreferencesCatalogGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetCatalogApiV1NotificationPreferencesCatalogGet<
  TData = Awaited<
    ReturnType<typeof getCatalogApiV1NotificationPreferencesCatalogGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getCatalogApiV1NotificationPreferencesCatalogGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getCatalogApiV1NotificationPreferencesCatalogGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getCatalogApiV1NotificationPreferencesCatalogGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetCatalogApiV1NotificationPreferencesCatalogGet<
  TData = Awaited<
    ReturnType<typeof getCatalogApiV1NotificationPreferencesCatalogGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getCatalogApiV1NotificationPreferencesCatalogGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Catalog
 */

export function useGetCatalogApiV1NotificationPreferencesCatalogGet<
  TData = Awaited<
    ReturnType<typeof getCatalogApiV1NotificationPreferencesCatalogGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getCatalogApiV1NotificationPreferencesCatalogGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetCatalogApiV1NotificationPreferencesCatalogGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get the notification events catalog for a specific module.
 * @summary Get Module Catalog
 */
export const getModuleCatalogApiV1NotificationPreferencesCatalogModuleGet = (
  module: string,
  signal?: AbortSignal
) => {
  return customInstance<NotificationModuleCatalogResponse>({
    url: `/api/v1/notification-preferences/catalog/${module}`,
    method: 'GET',
    signal
  });
};

export const getGetModuleCatalogApiV1NotificationPreferencesCatalogModuleGetQueryKey =
  (module?: string) => {
    return [`/api/v1/notification-preferences/catalog/${module}`] as const;
  };

export const getGetModuleCatalogApiV1NotificationPreferencesCatalogModuleGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getModuleCatalogApiV1NotificationPreferencesCatalogModuleGet
      >
    >,
    TError = HTTPValidationError
  >(
    module: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getModuleCatalogApiV1NotificationPreferencesCatalogModuleGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetModuleCatalogApiV1NotificationPreferencesCatalogModuleGetQueryKey(
        module
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getModuleCatalogApiV1NotificationPreferencesCatalogModuleGet
        >
      >
    > = ({ signal }) =>
      getModuleCatalogApiV1NotificationPreferencesCatalogModuleGet(
        module,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!module,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getModuleCatalogApiV1NotificationPreferencesCatalogModuleGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetModuleCatalogApiV1NotificationPreferencesCatalogModuleGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getModuleCatalogApiV1NotificationPreferencesCatalogModuleGet
      >
    >
  >;
export type GetModuleCatalogApiV1NotificationPreferencesCatalogModuleGetQueryError =
  HTTPValidationError;

export function useGetModuleCatalogApiV1NotificationPreferencesCatalogModuleGet<
  TData = Awaited<
    ReturnType<
      typeof getModuleCatalogApiV1NotificationPreferencesCatalogModuleGet
    >
  >,
  TError = HTTPValidationError
>(
  module: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getModuleCatalogApiV1NotificationPreferencesCatalogModuleGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getModuleCatalogApiV1NotificationPreferencesCatalogModuleGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getModuleCatalogApiV1NotificationPreferencesCatalogModuleGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetModuleCatalogApiV1NotificationPreferencesCatalogModuleGet<
  TData = Awaited<
    ReturnType<
      typeof getModuleCatalogApiV1NotificationPreferencesCatalogModuleGet
    >
  >,
  TError = HTTPValidationError
>(
  module: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getModuleCatalogApiV1NotificationPreferencesCatalogModuleGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getModuleCatalogApiV1NotificationPreferencesCatalogModuleGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getModuleCatalogApiV1NotificationPreferencesCatalogModuleGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetModuleCatalogApiV1NotificationPreferencesCatalogModuleGet<
  TData = Awaited<
    ReturnType<
      typeof getModuleCatalogApiV1NotificationPreferencesCatalogModuleGet
    >
  >,
  TError = HTTPValidationError
>(
  module: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getModuleCatalogApiV1NotificationPreferencesCatalogModuleGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Module Catalog
 */

export function useGetModuleCatalogApiV1NotificationPreferencesCatalogModuleGet<
  TData = Awaited<
    ReturnType<
      typeof getModuleCatalogApiV1NotificationPreferencesCatalogModuleGet
    >
  >,
  TError = HTTPValidationError
>(
  module: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getModuleCatalogApiV1NotificationPreferencesCatalogModuleGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetModuleCatalogApiV1NotificationPreferencesCatalogModuleGetQueryOptions(
      module,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Every catalog module's resolved preference matrix, in ONE request.

The central `/settings?tab=notifications` tab shows all ~23 catalog modules
at once. It used to fetch `GET /{module}` per module, so one page load meant
22 concurrent requests for an admin — each holding a request-pool connection
for its whole duration, against a pool whose ceiling is 15. Two users on the
page exhausted it and the losers got a 500 from
`QueuePool limit of size 5 overflow 10 reached` (production alarm
`db-pool-request-timeouts`, 2026-08-21). One request, three set-based
queries, whatever the catalog grows to.

Returns every module the catalog declares; the caller renders the subset its
viewer may see. That is the same data `GET /{module}` already serves to any
authenticated user, so it discloses nothing new — the catalog itself is
public (`GET /catalog`), and the values are the caller's OWN preference rows.
 * @summary Get All Preferences
 */
export const getAllPreferencesApiV1NotificationPreferencesGet = (
  signal?: AbortSignal
) => {
  return customInstance<NotificationAllPreferencesResponse>({
    url: `/api/v1/notification-preferences`,
    method: 'GET',
    signal
  });
};

export const getGetAllPreferencesApiV1NotificationPreferencesGetQueryKey =
  () => {
    return [`/api/v1/notification-preferences`] as const;
  };

export const getGetAllPreferencesApiV1NotificationPreferencesGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getAllPreferencesApiV1NotificationPreferencesGet>
  >,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<
        ReturnType<typeof getAllPreferencesApiV1NotificationPreferencesGet>
      >,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetAllPreferencesApiV1NotificationPreferencesGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAllPreferencesApiV1NotificationPreferencesGet>>
  > = ({ signal }) => getAllPreferencesApiV1NotificationPreferencesGet(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<typeof getAllPreferencesApiV1NotificationPreferencesGet>
    >,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetAllPreferencesApiV1NotificationPreferencesGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getAllPreferencesApiV1NotificationPreferencesGet>>
  >;
export type GetAllPreferencesApiV1NotificationPreferencesGetQueryError =
  unknown;

export function useGetAllPreferencesApiV1NotificationPreferencesGet<
  TData = Awaited<
    ReturnType<typeof getAllPreferencesApiV1NotificationPreferencesGet>
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getAllPreferencesApiV1NotificationPreferencesGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getAllPreferencesApiV1NotificationPreferencesGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getAllPreferencesApiV1NotificationPreferencesGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetAllPreferencesApiV1NotificationPreferencesGet<
  TData = Awaited<
    ReturnType<typeof getAllPreferencesApiV1NotificationPreferencesGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getAllPreferencesApiV1NotificationPreferencesGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getAllPreferencesApiV1NotificationPreferencesGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getAllPreferencesApiV1NotificationPreferencesGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAllPreferencesApiV1NotificationPreferencesGet<
  TData = Awaited<
    ReturnType<typeof getAllPreferencesApiV1NotificationPreferencesGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getAllPreferencesApiV1NotificationPreferencesGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get All Preferences
 */

export function useGetAllPreferencesApiV1NotificationPreferencesGet<
  TData = Awaited<
    ReturnType<typeof getAllPreferencesApiV1NotificationPreferencesGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getAllPreferencesApiV1NotificationPreferencesGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetAllPreferencesApiV1NotificationPreferencesGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get resolved notification preferences matrix for the current user.
 * @summary Get Preferences
 */
export const getPreferencesApiV1NotificationPreferencesModuleGet = (
  module: string,
  signal?: AbortSignal
) => {
  return customInstance<NotificationPreferencesResponse>({
    url: `/api/v1/notification-preferences/${module}`,
    method: 'GET',
    signal
  });
};

export const getGetPreferencesApiV1NotificationPreferencesModuleGetQueryKey = (
  module?: string
) => {
  return [`/api/v1/notification-preferences/${module}`] as const;
};

export const getGetPreferencesApiV1NotificationPreferencesModuleGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getPreferencesApiV1NotificationPreferencesModuleGet>
    >,
    TError = HTTPValidationError
  >(
    module: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getPreferencesApiV1NotificationPreferencesModuleGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetPreferencesApiV1NotificationPreferencesModuleGetQueryKey(module);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getPreferencesApiV1NotificationPreferencesModuleGet>
      >
    > = ({ signal }) =>
      getPreferencesApiV1NotificationPreferencesModuleGet(module, signal);

    return {
      queryKey,
      queryFn,
      enabled: !!module,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getPreferencesApiV1NotificationPreferencesModuleGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetPreferencesApiV1NotificationPreferencesModuleGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getPreferencesApiV1NotificationPreferencesModuleGet>
    >
  >;
export type GetPreferencesApiV1NotificationPreferencesModuleGetQueryError =
  HTTPValidationError;

export function useGetPreferencesApiV1NotificationPreferencesModuleGet<
  TData = Awaited<
    ReturnType<typeof getPreferencesApiV1NotificationPreferencesModuleGet>
  >,
  TError = HTTPValidationError
>(
  module: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getPreferencesApiV1NotificationPreferencesModuleGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getPreferencesApiV1NotificationPreferencesModuleGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getPreferencesApiV1NotificationPreferencesModuleGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetPreferencesApiV1NotificationPreferencesModuleGet<
  TData = Awaited<
    ReturnType<typeof getPreferencesApiV1NotificationPreferencesModuleGet>
  >,
  TError = HTTPValidationError
>(
  module: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getPreferencesApiV1NotificationPreferencesModuleGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getPreferencesApiV1NotificationPreferencesModuleGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getPreferencesApiV1NotificationPreferencesModuleGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetPreferencesApiV1NotificationPreferencesModuleGet<
  TData = Awaited<
    ReturnType<typeof getPreferencesApiV1NotificationPreferencesModuleGet>
  >,
  TError = HTTPValidationError
>(
  module: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getPreferencesApiV1NotificationPreferencesModuleGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Preferences
 */

export function useGetPreferencesApiV1NotificationPreferencesModuleGet<
  TData = Awaited<
    ReturnType<typeof getPreferencesApiV1NotificationPreferencesModuleGet>
  >,
  TError = HTTPValidationError
>(
  module: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getPreferencesApiV1NotificationPreferencesModuleGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetPreferencesApiV1NotificationPreferencesModuleGetQueryOptions(
      module,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Bulk update per-event notification preferences.
 * @summary Update Event Preferences
 */
export const updateEventPreferencesApiV1NotificationPreferencesModuleEventsPut =
  (
    module: string,
    notificationBulkEventPreferenceUpdate: NotificationBulkEventPreferenceUpdate
  ) => {
    return customInstance<NotificationPreferenceUpdateResult>({
      url: `/api/v1/notification-preferences/${module}/events`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: notificationBulkEventPreferenceUpdate
    });
  };

export const getUpdateEventPreferencesApiV1NotificationPreferencesModuleEventsPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateEventPreferencesApiV1NotificationPreferencesModuleEventsPut
        >
      >,
      TError,
      { module: string; data: NotificationBulkEventPreferenceUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateEventPreferencesApiV1NotificationPreferencesModuleEventsPut
      >
    >,
    TError,
    { module: string; data: NotificationBulkEventPreferenceUpdate },
    TContext
  > => {
    const mutationKey = [
      'updateEventPreferencesApiV1NotificationPreferencesModuleEventsPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateEventPreferencesApiV1NotificationPreferencesModuleEventsPut
        >
      >,
      { module: string; data: NotificationBulkEventPreferenceUpdate }
    > = (props) => {
      const { module, data } = props ?? {};

      return updateEventPreferencesApiV1NotificationPreferencesModuleEventsPut(
        module,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateEventPreferencesApiV1NotificationPreferencesModuleEventsPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateEventPreferencesApiV1NotificationPreferencesModuleEventsPut
      >
    >
  >;
export type UpdateEventPreferencesApiV1NotificationPreferencesModuleEventsPutMutationBody =
  NotificationBulkEventPreferenceUpdate;
export type UpdateEventPreferencesApiV1NotificationPreferencesModuleEventsPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Event Preferences
 */
export const useUpdateEventPreferencesApiV1NotificationPreferencesModuleEventsPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof updateEventPreferencesApiV1NotificationPreferencesModuleEventsPut
          >
        >,
        TError,
        { module: string; data: NotificationBulkEventPreferenceUpdate },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof updateEventPreferencesApiV1NotificationPreferencesModuleEventsPut
      >
    >,
    TError,
    { module: string; data: NotificationBulkEventPreferenceUpdate },
    TContext
  > => {
    const mutationOptions =
      getUpdateEventPreferencesApiV1NotificationPreferencesModuleEventsPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Update module-level notification preferences (tier, channel toggles).

``tier_threshold`` is validated by the request schema's own enum, which rejects an
off-list value at the FastAPI boundary — the hand-written check that used to sit here
became unreachable the moment the model was generated from JSON Schema.
 * @summary Update Module Preferences
 */
export const updateModulePreferencesApiV1NotificationPreferencesModuleModulePut =
  (
    module: string,
    notificationModulePreferenceUpdate: NotificationModulePreferenceUpdate
  ) => {
    return customInstance<NotificationModulePreferences>({
      url: `/api/v1/notification-preferences/${module}/module`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: notificationModulePreferenceUpdate
    });
  };

export const getUpdateModulePreferencesApiV1NotificationPreferencesModuleModulePutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateModulePreferencesApiV1NotificationPreferencesModuleModulePut
        >
      >,
      TError,
      { module: string; data: NotificationModulePreferenceUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateModulePreferencesApiV1NotificationPreferencesModuleModulePut
      >
    >,
    TError,
    { module: string; data: NotificationModulePreferenceUpdate },
    TContext
  > => {
    const mutationKey = [
      'updateModulePreferencesApiV1NotificationPreferencesModuleModulePut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateModulePreferencesApiV1NotificationPreferencesModuleModulePut
        >
      >,
      { module: string; data: NotificationModulePreferenceUpdate }
    > = (props) => {
      const { module, data } = props ?? {};

      return updateModulePreferencesApiV1NotificationPreferencesModuleModulePut(
        module,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateModulePreferencesApiV1NotificationPreferencesModuleModulePutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateModulePreferencesApiV1NotificationPreferencesModuleModulePut
      >
    >
  >;
export type UpdateModulePreferencesApiV1NotificationPreferencesModuleModulePutMutationBody =
  NotificationModulePreferenceUpdate;
export type UpdateModulePreferencesApiV1NotificationPreferencesModuleModulePutMutationError =
  HTTPValidationError;

/**
 * @summary Update Module Preferences
 */
export const useUpdateModulePreferencesApiV1NotificationPreferencesModuleModulePut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof updateModulePreferencesApiV1NotificationPreferencesModuleModulePut
          >
        >,
        TError,
        { module: string; data: NotificationModulePreferenceUpdate },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof updateModulePreferencesApiV1NotificationPreferencesModuleModulePut
      >
    >,
    TError,
    { module: string; data: NotificationModulePreferenceUpdate },
    TContext
  > => {
    const mutationOptions =
      getUpdateModulePreferencesApiV1NotificationPreferencesModuleModulePutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Reset all notification preferences to defaults for a module.
 * @summary Reset Preferences
 */
export const resetPreferencesApiV1NotificationPreferencesModuleResetPost = (
  module: string,
  signal?: AbortSignal
) => {
  return customInstance<NotificationPreferenceResetResult>({
    url: `/api/v1/notification-preferences/${module}/reset`,
    method: 'POST',
    signal
  });
};

export const getResetPreferencesApiV1NotificationPreferencesModuleResetPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof resetPreferencesApiV1NotificationPreferencesModuleResetPost
        >
      >,
      TError,
      { module: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof resetPreferencesApiV1NotificationPreferencesModuleResetPost
      >
    >,
    TError,
    { module: string },
    TContext
  > => {
    const mutationKey = [
      'resetPreferencesApiV1NotificationPreferencesModuleResetPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof resetPreferencesApiV1NotificationPreferencesModuleResetPost
        >
      >,
      { module: string }
    > = (props) => {
      const { module } = props ?? {};

      return resetPreferencesApiV1NotificationPreferencesModuleResetPost(
        module
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ResetPreferencesApiV1NotificationPreferencesModuleResetPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof resetPreferencesApiV1NotificationPreferencesModuleResetPost
      >
    >
  >;

export type ResetPreferencesApiV1NotificationPreferencesModuleResetPostMutationError =
  HTTPValidationError;

/**
 * @summary Reset Preferences
 */
export const useResetPreferencesApiV1NotificationPreferencesModuleResetPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof resetPreferencesApiV1NotificationPreferencesModuleResetPost
        >
      >,
      TError,
      { module: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof resetPreferencesApiV1NotificationPreferencesModuleResetPost
    >
  >,
  TError,
  { module: string },
  TContext
> => {
  const mutationOptions =
    getResetPreferencesApiV1NotificationPreferencesModuleResetPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Get tenant-level default overrides for a module (admin only).
 * @summary Get Tenant Defaults
 */
export const getTenantDefaultsApiV1NotificationPreferencesAdminModuleDefaultsGet =
  (module: string, signal?: AbortSignal) => {
    return customInstance<NotificationTenantDefaultsResponse>({
      url: `/api/v1/notification-preferences/admin/${module}/defaults`,
      method: 'GET',
      signal
    });
  };

export const getGetTenantDefaultsApiV1NotificationPreferencesAdminModuleDefaultsGetQueryKey =
  (module?: string) => {
    return [
      `/api/v1/notification-preferences/admin/${module}/defaults`
    ] as const;
  };

export const getGetTenantDefaultsApiV1NotificationPreferencesAdminModuleDefaultsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getTenantDefaultsApiV1NotificationPreferencesAdminModuleDefaultsGet
      >
    >,
    TError = HTTPValidationError
  >(
    module: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getTenantDefaultsApiV1NotificationPreferencesAdminModuleDefaultsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetTenantDefaultsApiV1NotificationPreferencesAdminModuleDefaultsGetQueryKey(
        module
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getTenantDefaultsApiV1NotificationPreferencesAdminModuleDefaultsGet
        >
      >
    > = ({ signal }) =>
      getTenantDefaultsApiV1NotificationPreferencesAdminModuleDefaultsGet(
        module,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!module,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getTenantDefaultsApiV1NotificationPreferencesAdminModuleDefaultsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetTenantDefaultsApiV1NotificationPreferencesAdminModuleDefaultsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getTenantDefaultsApiV1NotificationPreferencesAdminModuleDefaultsGet
      >
    >
  >;
export type GetTenantDefaultsApiV1NotificationPreferencesAdminModuleDefaultsGetQueryError =
  HTTPValidationError;

export function useGetTenantDefaultsApiV1NotificationPreferencesAdminModuleDefaultsGet<
  TData = Awaited<
    ReturnType<
      typeof getTenantDefaultsApiV1NotificationPreferencesAdminModuleDefaultsGet
    >
  >,
  TError = HTTPValidationError
>(
  module: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTenantDefaultsApiV1NotificationPreferencesAdminModuleDefaultsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getTenantDefaultsApiV1NotificationPreferencesAdminModuleDefaultsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getTenantDefaultsApiV1NotificationPreferencesAdminModuleDefaultsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTenantDefaultsApiV1NotificationPreferencesAdminModuleDefaultsGet<
  TData = Awaited<
    ReturnType<
      typeof getTenantDefaultsApiV1NotificationPreferencesAdminModuleDefaultsGet
    >
  >,
  TError = HTTPValidationError
>(
  module: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTenantDefaultsApiV1NotificationPreferencesAdminModuleDefaultsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getTenantDefaultsApiV1NotificationPreferencesAdminModuleDefaultsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getTenantDefaultsApiV1NotificationPreferencesAdminModuleDefaultsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTenantDefaultsApiV1NotificationPreferencesAdminModuleDefaultsGet<
  TData = Awaited<
    ReturnType<
      typeof getTenantDefaultsApiV1NotificationPreferencesAdminModuleDefaultsGet
    >
  >,
  TError = HTTPValidationError
>(
  module: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTenantDefaultsApiV1NotificationPreferencesAdminModuleDefaultsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Tenant Defaults
 */

export function useGetTenantDefaultsApiV1NotificationPreferencesAdminModuleDefaultsGet<
  TData = Awaited<
    ReturnType<
      typeof getTenantDefaultsApiV1NotificationPreferencesAdminModuleDefaultsGet
    >
  >,
  TError = HTTPValidationError
>(
  module: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTenantDefaultsApiV1NotificationPreferencesAdminModuleDefaultsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetTenantDefaultsApiV1NotificationPreferencesAdminModuleDefaultsGetQueryOptions(
      module,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update tenant-level default overrides for a module (admin only).
 * @summary Update Tenant Defaults
 */
export const updateTenantDefaultsApiV1NotificationPreferencesAdminModuleDefaultsPut =
  (
    module: string,
    notificationBulkTenantDefaultUpdate: NotificationBulkTenantDefaultUpdate
  ) => {
    return customInstance<NotificationPreferenceUpdateResult>({
      url: `/api/v1/notification-preferences/admin/${module}/defaults`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: notificationBulkTenantDefaultUpdate
    });
  };

export const getUpdateTenantDefaultsApiV1NotificationPreferencesAdminModuleDefaultsPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateTenantDefaultsApiV1NotificationPreferencesAdminModuleDefaultsPut
        >
      >,
      TError,
      { module: string; data: NotificationBulkTenantDefaultUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateTenantDefaultsApiV1NotificationPreferencesAdminModuleDefaultsPut
      >
    >,
    TError,
    { module: string; data: NotificationBulkTenantDefaultUpdate },
    TContext
  > => {
    const mutationKey = [
      'updateTenantDefaultsApiV1NotificationPreferencesAdminModuleDefaultsPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateTenantDefaultsApiV1NotificationPreferencesAdminModuleDefaultsPut
        >
      >,
      { module: string; data: NotificationBulkTenantDefaultUpdate }
    > = (props) => {
      const { module, data } = props ?? {};

      return updateTenantDefaultsApiV1NotificationPreferencesAdminModuleDefaultsPut(
        module,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateTenantDefaultsApiV1NotificationPreferencesAdminModuleDefaultsPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateTenantDefaultsApiV1NotificationPreferencesAdminModuleDefaultsPut
      >
    >
  >;
export type UpdateTenantDefaultsApiV1NotificationPreferencesAdminModuleDefaultsPutMutationBody =
  NotificationBulkTenantDefaultUpdate;
export type UpdateTenantDefaultsApiV1NotificationPreferencesAdminModuleDefaultsPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Tenant Defaults
 */
export const useUpdateTenantDefaultsApiV1NotificationPreferencesAdminModuleDefaultsPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof updateTenantDefaultsApiV1NotificationPreferencesAdminModuleDefaultsPut
          >
        >,
        TError,
        { module: string; data: NotificationBulkTenantDefaultUpdate },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof updateTenantDefaultsApiV1NotificationPreferencesAdminModuleDefaultsPut
      >
    >,
    TError,
    { module: string; data: NotificationBulkTenantDefaultUpdate },
    TContext
  > => {
    const mutationOptions =
      getUpdateTenantDefaultsApiV1NotificationPreferencesAdminModuleDefaultsPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
